import TraitsListOfKit from './TraitsListOfKit'

export default TraitsListOfKit
